import { Props } from '../Layout/TabBar'

export type Params = {
  activeTab: Props['activeTab']
}

export const useTabBarProps = ({ activeTab }: Params): Props => {
  return {
    activeTab,
  }
}
